<template>
  <v-card>
    <v-system-bar>Lehrpersonen-Flipper</v-system-bar>
    <v-card-text>
      <Flipper
        :value="filteredTeachers"
        :name="`flipper_teachers_d${filterDivision}_fs${filterDepartment}_stvs${filterStvs}_new${filterNew}`"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { defineComponent } from "vue";
import Flipper from "@/components/Flipper.vue";
import PersonItem from "common/components/PersonItem.vue";
import PeoplePanel from "common/components/PeoplePanel.vue";

import { sortPeople } from "common/utils/people.js";

export default defineComponent({
  name: "TeacherFlipper",
  components: { Flipper, PersonItem, PeoplePanel },
  props: ["filterDepartment", "filterDivision", "filterNew", "filterStvs"],

  data() {
    return {
      view: "list",
      teachers: [],
      loading: false,
    };
  },
  watch: {
    filterDepartment() {
      this.fetchData();
    },
    filterNew() {
      this.fetchData();
    },
  },
  methods: {
    async fetchData() {
      this.teachers = [];
      this.loading = true;
      if (this.filterNew) {
        this.teachers = await this.apiList({
          resource: "person/person",
          query: `group=teacher&new=true`,
        });
      } else if (this.filterDepartment > 0) {
        const department = await this.apiGet({
          resource: "person/department",
          id: this.filterDepartment,
        });

        this.teachers = [...department.heads, ...department.members]
          // eslint-disable-next-line no-unused-vars
          .map(({ description, ...el }) => el);
      } else {
        this.teachers = await this.apiList({
          resource: "person/person",
          query: `group=teacher`,
        });
      }
      this.loading = false;
    },
  },

  computed: {
    codes() {
      return this.filteredTeachers.filter((el) => el.code).map((el) => el.code);
    },
    filteredTeachers() {
      return sortPeople(
        this.teachers.filter(
          (el) =>
            el.portraitAvailable &&
            (this.filterStvs || (el.code && el.code.length == 3)) &&
            (el.division == null ||
              this.filterDivision == 0 ||
              this.filterDivision == el.division.id)
        )
      );
    },
  },
  async created() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  },
});
</script>
